var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 0.000244141C3.50156 0.000244141 3 0.501807 3 1.12524C3 2.94868 4.09687 3.90962 4.83281 4.55181L4.88437 4.59868C5.64844 5.26431 6 5.62056 6 6.37524C6 6.99868 6.50156 7.50024 7.125 7.50024C7.74844 7.50024 8.25 6.99868 8.25 6.37524C8.25 4.55181 7.15312 3.59087 6.41719 2.94868L6.36563 2.90181C5.60156 2.23618 5.25 1.87993 5.25 1.12524C5.25 0.501807 4.74844 0.000244141 4.125 0.000244141ZM1.5 9.00024C0.670312 9.00024 0 9.67056 0 10.5002V19.5002C0 21.9846 2.01562 24.0002 4.5 24.0002H13.5C15.9844 24.0002 18 21.9846 18 19.5002H18.75C21.6516 19.5002 24 17.1518 24 14.2502C24 11.3487 21.6516 9.00024 18.75 9.00024H16.5H1.5ZM18 12.0002H18.75C19.9922 12.0002 21 13.0081 21 14.2502C21 15.4924 19.9922 16.5002 18.75 16.5002H18V12.0002ZM10.5 1.12524C10.5 0.501807 9.99844 0.000244141 9.375 0.000244141C8.75156 0.000244141 8.25 0.501807 8.25 1.12524C8.25 2.94868 9.34688 3.90962 10.0828 4.55181L10.1344 4.59868C10.8984 5.26431 11.25 5.62056 11.25 6.37524C11.25 6.99868 11.7516 7.50024 12.375 7.50024C12.9984 7.50024 13.5 6.99868 13.5 6.37524C13.5 4.55181 12.4031 3.59087 11.6672 2.94868L11.6156 2.90181C10.8516 2.23618 10.5 1.87993 10.5 1.12524Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMug);
export default __webpack_public_path__ + "static/media/mug.fdd390ff4380200c468808b92748b74b.svg";
export { ForwardRef as ReactComponent };